module.exports = __webpack_public_path__ + "img/review_b.4456a011.svg";